import Vue from 'vue'
import VueRouter from 'vue-router'
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc'
import Home from '../views/Home.vue'
import store from '@/store';
import { userRoutes } from "./users";
import { circleRoutes } from "./circles";
import { configurationRoutes } from './configuration';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
  },
  {
    path: '/calendar',
    component: () => import('@/components/calendar/Home.vue'),
    children: [
      {
        path: "",
        name: 'Calendar',
        redirect: "my-calendar"
      },
      {
        path: "my-calendar",
        component: () => import("@/components/calendar/CalendarSmall.vue")
      },      {
        path: "group-overview",
        component: () => import("@/components/calendar/GroupOverview.vue")
      },
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: {
      isPublic: true
    }
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import('../views/Logout.vue'),
    meta: {
      isPublic: true
    }
  },
  {
    path: '/oidc-callback', // Needs to match redirectUrl in oidcSettings
    name: 'oidcCallback',
    component: () => import('../views/OidcCallback.vue'),
    meta: {
      isPublic: true
    }
  },
  {
    path: '/oidc-popup-callback', // Needs to match popupRedirectUrl in oidcSettings
    name: 'oidcPopupCallback',
    component: () => import('../views/OidcPopupCallback.vue'),
    meta: {
      isPublic: true
    }
  },
  {
    path: '/oidc-callback-error', // Needs to match redirect_uri in oidcSettings
    name: 'oidcCallbackError',
    component: () => import('../views/OidcCallbackError.vue'),
    meta: {
      isPublic: true
    }
  },
  {
    path: '/replacementweek',
    name: 'ReplacementWeek',
    component: () => import('../views/ReplacementWeek.vue')
  },
  {
    path: "/schedule",
    component: () => import("@/views/ScheduleTop.vue"),
    children: [
      {
        path: "",
        name: "Schedule",
        component: () => import("@/components/scheduler/Schedule.vue"),
      },
      {
        path: "disposition",
        name: "Disposition",
        component: () => import("@/views/Disposition.vue")
      }
    ]
  },
  {
    path: "/configuration-user",
    component: () => import("@/views/ConfigurationUserTop.vue"),
    children: [      
      {
        path: "",
        name: 'My-Groups',
        redirect: "my-groups"
      },
      {
        path: 'my-groups',
        name: 'My-Groups',
        component: () => import('@/views/group-views/GroupsForUser.vue')
      },
      {
        path: 'my-groups/:groupId/group',
        name: 'Group',
        props: true,
        component: () => import('@/views/group-views/Group.vue')
      },
      {
        path: 'my-groups/new',
        name: 'NewGroup',
        component: () => import('@/views/group-views/Group.vue')
      },
    ]
  },
  {
    path: '/reports',
    component: () => import('@/views/Reports.vue'),
    children: [
      {
        path: '',
        name: 'Reports',
        redirect: "monthlystatistics"
      },
      {
        path: 'replacementstatistics',
        name: 'ReplacementStatistics',
        component: () => import("@/views/reports/ReplacementStatistics.vue")
      },
      {
        path: 'generalstatistics',
        name: 'GeneralStatistics',
        component: () => import("@/views/reports/GeneralStatistics.vue")
      },
      {
        path: 'drivestatistics',
        name: 'DriveStatistics',
        component: () => import("@/views/reports/DriveStatistics.vue")
      },
      {
        path: 'absencestatistics',
        name: 'AbsenceStatistics',
        component: () => import("@/views/reports/AbsenceStatistics.vue")
      },
      {
        path: 'replacementmonthlystatistics',
        name: 'ReplacementMonthlyStatistics',
        props: true,
        component: () => import("@/views/reports/ReplacementMonthlyStatistics.vue")
      },
      {
        path: 'monthlystatistics',
        name: 'MonthlyStatistics',
        props: true,
        component: () => import("@/views/reports/MonthlyStatistics.vue")
      },
      {
        path: 'monthlygroup',
        name: 'MonthlyGroup',
        props: true,
        component: () => import("@/views/reports/MonthlyGroup.vue")
      },
      {
        path: 'yearlytimeregistration',
        name: 'YearlyTimeRegistration',
        props: true,
        component: () => import("@/views/reports/YearlyTimeRegistrationReport.vue")
      },
      {
        path: 'timeoff',
        name: 'TimeOff',
        props: true,
        component: () => import("@/views/reports/TimeOffReport.vue")
      },
      {
        path: 'salaryReport',
        name: 'SalaryReport',
        props: true,
        component: () => import("@/views/reports/SalaryReport.vue")
      },
      {
        path: 'totalSalaryReport',
        name: 'TotalSalaryReport',
        props: true,
        component: () => import("@/views/reports/TotalSalaryReport.vue")
      },
      {
        path: 'salaryDayReport',
        name: 'SalaryDayReport',
        props: true,
        component: () => import("@/views/reports/SalaryDayReport.vue")
      },
      {
        path: 'dtReport',
        name: 'DTReport',
        component: () => import("@/views/reports/DTReport.vue")
      },
    ]
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue')
  },
  {
    path: '/icalendar',
    name: 'ICalendar',
    component: () => import('../views/ICalendar.vue')
  },
  //...circleRoutes,
  ...configurationRoutes,
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: 'is-active'
});

router.beforeEach(vuexOidcCreateRouterMiddleware(store, 'oidcStore'));

export default router
